import {FC, useEffect, useMemo} from 'react'
import {Outlet, useLocation} from "react-router-dom"
import Head from './components/Head'
import Top from './components/Top'
import Footer from './components/Footer'
import {useUserInfoContext} from "@/store/userInfo"
import AiMenu from './components/AiMenu'
import style from './style.module.less'

const BaseLayout: FC = () => {
    const location = useLocation()
    const {baseInfo} = useUserInfoContext()

    const hasAiMenu = useMemo(() => {
        if(baseInfo && baseInfo.qx && baseInfo.qx.jcqx) {
            const jcqx = JSON.parse(baseInfo.qx.jcqx)
            if(jcqx.aiqx + '' === '1') {
                return true
            }
        }
        return false
    }, [baseInfo])

    return (
        <div className={location.pathname === '/doc' ? 'bg-white' : ''}>
            <Head/>
            <Top/>
            <div className={style.container}>
                <Outlet/>
            </div>
            <Footer/>
            {
                hasAiMenu && <AiMenu />
            }
        </div>
    )
}

export default BaseLayout
